import styles from "./dashboardCardStyles.module.css";

function DashboardCard({ count, title, detail, accent = "brand", icon = "pi pi-chart-bar" }) {
  return (
    <div className={`${styles.dashboardCard} ${styles[accent] || ""}`}>
      <div className={styles.cardHeader}>
        <span className={styles.cardLabel}>{title}</span>
        <span className={styles.iconWrap}>
          <i className={icon} />
        </span>
      </div>
      <div className={styles.count}>{count}</div>
      {detail ? <p className={styles.detail}>{detail}</p> : null}
    </div>
  );
}

export default DashboardCard;
